import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import UnathorizedRoutes from "./routes/AuthorizedRoutes";
import AuthorizedRoutes from "./routes/UnathorizedRoutes";
import { BrowserRouter, Routes, Route, Outlet, Link } from "react-router-dom";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {UnathorizedRoutes()}
          {AuthorizedRoutes()}
        </Routes>
      </BrowserRouter>
      <ToastContainer
        className="toast-container"
        // hideProgressBar
        // autoClose={2000}

        autoClose={3000}
        hideProgressBar
        theme="colored"
      />
    </>
  );
}

export default App;
